var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.20711 7.12377C3.81658 6.73325 3.81658 6.10008 4.20711 5.70956L5.70956 4.20711C6.10008 3.81658 6.73325 3.81658 7.12377 4.20711L13.2929 10.3762C13.6834 10.7668 14.3166 10.7668 14.7071 10.3762L20.8762 4.20711C21.2668 3.81658 21.8999 3.81658 22.2904 4.20711L23.7929 5.70956C24.1834 6.10008 24.1834 6.73325 23.7929 7.12377L17.6238 13.2929C17.2332 13.6834 17.2332 14.3166 17.6238 14.7071L23.7929 20.8762C24.1834 21.2668 24.1834 21.8999 23.7929 22.2904L22.2904 23.7929C21.8999 24.1834 21.2668 24.1834 20.8762 23.7929L14.7071 17.6238C14.3166 17.2332 13.6834 17.2332 13.2929 17.6238L7.12377 23.7929C6.73325 24.1834 6.10008 24.1834 5.70956 23.7929L4.20711 22.2904C3.81658 21.8999 3.81658 21.2668 4.20711 20.8762L10.3762 14.7071C10.7668 14.3166 10.7668 13.6834 10.3762 13.2929L4.20711 7.12377Z",
    fill: "#AF2121",
    stroke: "#AF2121",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.661bd65e7732603699608d7f9a125ec6.svg";
export { ForwardRef as ReactComponent };